import { Stack, Typography } from "@mui/material";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import InvestorCommunicationContext from "../../InvestorCommunicationContext";
import InvestorCommunicationEngagementTiles from "./InvestorCommunicationEngagementTiles";
import InvestorCommunicationReadBreakdown from "./InvestorCommunicationReadBreakdown";
import InvestorCommunicationViewsChart from "./InvestorCommunicationViewsChart";

const InvestorCommunicationEngagementSection = () => {
  const { investorCommunication, engagement } = useDefinedContext(
    InvestorCommunicationContext,
    "InvestorCommunicationContext"
  );

  if (engagement === undefined) {
    return null;
  }

  return (
    <Stack spacing={2} sx={{ pt: 4 }}>
      <Stack spacing={0.5}>
        <Typography variant="subtitle1">Engagement</Typography>
        <Typography variant="caption" color="textSecondary">
          How investors viewed this update in the portal.
        </Typography>
      </Stack>

      <InvestorCommunicationEngagementTiles type={investorCommunication.type} summary={engagement.summary} />
      <InvestorCommunicationReadBreakdown type={investorCommunication.type} summary={engagement.summary} />
      {engagement.viewedAt.length > 0 && <InvestorCommunicationViewsChart viewedAt={engagement.viewedAt} />}
    </Stack>
  );
};

export default InvestorCommunicationEngagementSection;
